module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item-header"
  }, [_c('a', [_c('div', {
    staticClass: "icon-header",
    class: [(_vm.avatar == undefined || (_vm.avatar !== undefined && _vm.avatar === '')) && (_vm.icon === undefined || _vm.icon === '') ? 'remove-img' : '']
  }, [(_vm.avatar !== undefined && _vm.avatar !== '') ? _c('div', {
    staticClass: "avt-sidebar"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar
    }
  })]) : ((_vm.avatar === undefined || !_vm.avatar) && !_vm.isAwesome(_vm.icon)) ? _c('div', {
    staticClass: "material-icons text-gray"
  }, [_vm._v(_vm._s(_vm.icon))]) : _c('div', {
    staticClass: "fontawesome text-gray"
  }, [_c('i', {
    class: [_vm.icon != '' ? _vm.icon : '']
  })])]), _c('div', {
    staticClass: "text-header",
    class: [(_vm.avatar == undefined || (_vm.avatar !== undefined && _vm.avatar === '')) && (_vm.icon === undefined || _vm.icon === '') ? 'full-text' : '']
  }, [_c('span', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.title))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f45d873e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/itemHeader.vue
// module id = 1661
// module chunks = 0